import { useEffect, type CSSProperties } from "react";

export function ParticleBurst({ x, y, color, onDone }: { x: number; y: number; color: string; onDone?: () => void }) {
  useEffect(() => { const timer = window.setTimeout(onDone ?? (() => undefined), 680); return () => window.clearTimeout(timer); }, [onDone]);
  return <div className="particle-burst" style={{ left: `${x}%`, top: `${y}%`, "--particle-color": color } as CSSProperties} aria-hidden="true">
    {Array.from({ length: 14 }, (_, index) => <i key={index} style={{ "--angle": `${index * 25.7}deg`, "--distance": `${28 + index % 4 * 9}px`, "--delay": `${index % 4 * 18}ms` } as CSSProperties} />)}
  </div>;
}
